import { ToastsStore } from "react-toasts";
import {
  ADD_CUSTOMERS,
  ADD_PARTS_REVS,
  GET_CUSTOMERS,
  GET_PARTS_REVS,
  IMPORT_FILTER_DATA,
  LOGIN_REQUEST,
  SET_COLUMN,
  SET_COLUMN_ALIASES,
  SET_SYSTEM_SETTINGS,
  SET_USER,
  SIGNUP_REQUEST,
  UNSET_COLUMN,
  UNSET_COLUMN_ALIASES,
  UNSET_QUOTE,
  UNSET_SYSTEM_SETTINGS,
  UNSET_USER,
  UPDATE_PROFILE,
  UPDATE_QUOTES,
  UPDATE_TOKEN,
} from "../constants/actionTypes";
import {
  ADD_ATTRITION,
  ADD_BOMCHECKLIST,
  ADD_PACKAGE_LEAD_TYPE,
  ADD_SYSTEM_SETTING,
  ADD_USER,
  BOM_HISTORY,
  CHANGE_PASSWORD,
  CHECK_ATTRITION_PACKAGES,
  COLUMNS_LIST,
  COLUMN_ALIASES,
  CUSTOMERS,
  CUSTOMERS_LIST,
  DELETE_ATTRITION,
  DELETE_BOMCHECKLIST,
  DELETE_PACKAGE_LEAD_TYPE,
  DELETE_PART,
  DELETE_SYSTEM_SETTING,
  DELETE_USER,
  DIGIKEY_ENRICH,
  DISTRIBUTORS_LIST,
  FORGOT_PASSWORD,
  GET_ATTRITIONS,
  GET_BOMCHECKLISTS,
  GET_FILE,
  GET_PACKAGE_LEAD_TYPES,
  GET_PARTS_CATALOG,
  GET_ROLES,
  GET_SYSTEM_SETTINGS,
  GET_USERS,
  INSERT_ATTRITION_LIST,
  LOGIN,
  LOGOUT,
  PARTS_REVS_LIST,
  SAVE_PARTS_REVS,
  SHARE_BOM,
  SIGNUP,
  STORE_RESULTANT_BOM,
  UPDATE_ATTRITION,
  UPDATE_BOMCHECKLIST,
  UPDATE_PACKAGE_LEAD_TYPE,
  UPDATE_SYSTEM_SETTING,
  UPDATE_USER,
  UPDATE_VENDOR_LIST,
} from "../constants/urls";
import { toaster } from "../function";
import { delet, get, post, put } from "../helpers";

export const signup =
  ({ email, password, firstName, lastName, mobile }) =>
  (dispatch) => {
    dispatch({ type: SIGNUP_REQUEST });
    post({
      url: SIGNUP,
      body: { email, password, firstName, lastName, mobile },
      success: SET_USER,
      failure: UNSET_USER,
      dispatch,
    });
  };

export const login =
  ({ email, password }) =>
  async (dispatch) => {
    dispatch({ type: LOGIN_REQUEST });
    const data = await post({
      url: LOGIN,
      body: { email, password },
      failure: UNSET_USER,
      dispatch,
    });

    if (!data) {
      dispatch({ type: UNSET_USER });
      return { code: 0, message: "Unable to reach server. Please try again." };
    }

    if (data.code >= 200 && data.code < 400) {
      if (data.data.is_allowed_ip === false) {
        dispatch({ type: UNSET_USER });
        return data;
      }
      if (data.data.user.is_active) {
        dispatch({ type: SET_USER, data: data.data });
      }
      return data;
    } else {
      dispatch({ type: UNSET_USER });
      return data;
    }
  };

export const logout = (token) => async (dispatch) => {
  const data = await post({
    url: LOGOUT,
    body: {},
    headers: {
      authorization: "Bearer " + token,
    },
    success: UNSET_USER,
    failure: UNSET_USER,
    dispatch,
  });

  if (data.code >= 200 && data.code < 400) {
    dispatch({ type: UNSET_USER });
    dispatch({ type: UNSET_COLUMN });
    dispatch({ type: UNSET_COLUMN_ALIASES });
    dispatch({ type: UNSET_QUOTE });
    dispatch({ type: UNSET_SYSTEM_SETTINGS });
    return data;
  } else {
    dispatch({ type: UNSET_USER });
    return data;
  }
};

export const forgotPassword =
  ({ email }) =>
  async (dispatch) => {
    dispatch({ type: UNSET_USER });
    const data = await post({
      url: FORGOT_PASSWORD,
      body: { email },
      failure: "",
      dispatch,
    });

    return data;
  };

export const getColumns = (token) => async (dispatch) => {
  const data = await get({
    url:
      localStorage.getItem("isDebug") === "1"
        ? COLUMNS_LIST + "?debug=1"
        : COLUMNS_LIST,
    success: SET_COLUMN,
    headers: {
      authorization: "Bearer " + token,
    },
    failure: "",
    dispatch,
  });

  if (data.code >= 200 && data.code < 400) {
    dispatch({ type: SET_COLUMN, data });
    return data;
  } else {
    if (data.message) toaster(ToastsStore, "error", data.message);
    dispatch({ type: "" });
    return data;
  }
};

export const getColumnAliases = (token) => async (dispatch) => {
  const data = await get({
    url:
      localStorage.getItem("isDebug") === "1"
        ? COLUMN_ALIASES + "?debug=1"
        : COLUMN_ALIASES,
    success: SET_COLUMN_ALIASES,
    headers: {
      authorization: "Bearer " + token,
    },
    failure: "",
    dispatch,
  });

  if (data.code >= 200 && data.code < 400) {
    dispatch({ type: SET_COLUMN_ALIASES, data });
    return data;
  } else {
    if (data.message) toaster(ToastsStore, "error", data.message);
    dispatch({ type: "" });
    return data;
  }
};

export const getCustomers = (token) => async (dispatch) => {
  const data = await get({
    url:
      localStorage.getItem("isDebug") === "1"
        ? CUSTOMERS_LIST + "?debug=1"
        : CUSTOMERS_LIST,
    success: GET_CUSTOMERS,
    headers: {
      authorization: "Bearer " + token,
    },
    failure: "",
    dispatch,
  });

  if (data.code >= 200 && data.code < 400) {
    dispatch({ type: GET_CUSTOMERS, data });
    return data;
  } else {
    if (data.message) toaster(ToastsStore, "error", data.message);
    dispatch({ type: "" });
    return data;
  }
};

export const saveCustomer = (token, data) => async (dispatch) => {
  const res = await post({
    url:
      localStorage.getItem("isDebug") === "1"
        ? CUSTOMERS + "?debug=1"
        : CUSTOMERS,
    body: data,
    headers: {
      authorization: "Bearer " + token,
    },
    success: "",
    failure: "",
    dispatch,
  });
  if (res.code >= 200 && res.code < 400) {
    dispatch({ type: ADD_CUSTOMERS, data: res.data });
    return res;
  } else {
    if (res.message) toaster(ToastsStore, "error", "There were some errors.");
    return res;
  }
};

export const changePassword = (token, data) => async (dispatch) => {
  const res = await post({
    url:
      localStorage.getItem("isDebug") === "1"
        ? CHANGE_PASSWORD + "?debug=1"
        : CHANGE_PASSWORD,
    body: data,
    headers: {
      authorization: "Bearer " + token,
    },
    success: "",
    failure: "",
    dispatch,
  });

  if (res.code >= 200 && res.code < 400) {
    dispatch({ type: UPDATE_TOKEN, data: res.data });
    return res;
  } else {
    if (res.message) toaster(ToastsStore, "error", res.message);
    return res;
  }
};

export const postImportRecords = (token, data) => (dispatch) => {
  dispatch({ type: IMPORT_FILTER_DATA, data });
};

export const getUser = (token) => async (dispatch) => {
  const data = await get({
    url:
      localStorage.getItem("isDebug") === "1"
        ? GET_USERS + "?debug=1"
        : GET_USERS,
    headers: {
      authorization: "Bearer " + token,
    },
    failure: "",
    dispatch,
  });

  if (data.code === 403) {
    return dispatch({ type: UNSET_USER });
  }

  if (data.code >= 200 && data.code < 400) {
    return data;
  } else {
    if (data.message) toaster(ToastsStore, "error", data.message);
    return data;
  }
};

export const addUser = (token, data) => async (dispatch) => {
  const res = await post({
    url:
      localStorage.getItem("isDebug") === "1"
        ? ADD_USER + "?debug=1"
        : ADD_USER,
    body: data,
    headers: {
      authorization: "Bearer " + token,
    },
    success: "",
    failure: "",
    dispatch,
  });

  if (res.code >= 200 && res.code < 400) {
    return res;
  } else {
    if (res.message)
      // toaster(ToastsStore, 'error', res.message)
      return res;
  }
};

export const editUser = (token, data) => async (dispatch) => {
  const res = await put({
    url:
      localStorage.getItem("isDebug") === "1"
        ? UPDATE_USER + `${data.id}?debug=1`
        : UPDATE_USER + `${data.id}`,
    body: data,
    headers: {
      authorization: "Bearer " + token,
    },
    success: "",
    failure: "",
    dispatch,
  });

  if (res.code >= 200 && res.code < 400) {
    return res;
  } else {
    if (res.message) toaster(ToastsStore, "error", res.message);
    return res;
  }
};

export const profileUpdate = (token, data) => async (dispatch) => {
  const res = await put({
    url:
      localStorage.getItem("isDebug") === "1"
        ? UPDATE_USER + `${data.id}?debug=1`
        : UPDATE_USER + `${data.id}`,
    body: data,
    headers: {
      authorization: "Bearer " + token,
    },
    success: "",
    failure: "",
    dispatch,
  });

  if (res.code >= 200 && res.code < 400) {
    dispatch({ type: UPDATE_PROFILE, data: res.data });
    return res;
  } else {
    if (res.message) toaster(ToastsStore, "error", res.message);
    return res;
  }
};

export const deleteUser = (token) => (dispatch) => {
  delet({
    url: DELETE_USER,
    success: UNSET_USER,
    body: {},
    headers: {
      authorization: "Bearer " + token,
    },
    failure: "",
    dispatch,
  });
};

export const getBomChecklist = (token) => async (dispatch) => {
  const data = await get({
    url:
      localStorage.getItem("isDebug") === "1"
        ? GET_BOMCHECKLISTS + "?debug=1"
        : GET_BOMCHECKLISTS,
    headers: {
      authorization: "Bearer " + token,
    },
    failure: "",
    dispatch,
  });

  if (data.code === 403) {
    return dispatch({ type: UNSET_USER });
  }

  if (data.code >= 200 && data.code < 400) {
    return data;
  } else {
    if (data.message) toaster(ToastsStore, "error", data.message);
    return data;
  }
};

export const addBomChecklist = (token, data) => async (dispatch) => {
  const res = await post({
    url:
      localStorage.getItem("isDebug") === "1"
        ? ADD_BOMCHECKLIST + "?debug=1"
        : ADD_BOMCHECKLIST,
    body: data,
    headers: {
      authorization: "Bearer " + token,
    },
    success: "",
    failure: "",
    dispatch,
  });

  if (res.code >= 200 && res.code < 400) {
    return res;
  } else {
    if (res.message)
      // toaster(ToastsStore, 'error', res.message)
      return res;
  }
};

export const editBomChecklist = (token, data) => async (dispatch) => {
  const res = await put({
    url:
      localStorage.getItem("isDebug") === "1"
        ? UPDATE_BOMCHECKLIST + `/${data.id}?debug=1`
        : UPDATE_BOMCHECKLIST + `/${data.id}`,
    body: data,
    headers: {
      authorization: "Bearer " + token,
    },
    success: "",
    failure: "",
    dispatch,
  });

  if (res.code >= 200 && res.code < 400) {
    return res;
  } else {
    if (res.message) toaster(ToastsStore, "error", res.message);
    return res;
  }
};

export const deleteBomChecklist = (token, data) => async (dispatch) => {
  const res = await delet({
    url:
      localStorage.getItem("isDebug") === "1"
        ? DELETE_BOMCHECKLIST + `${data.id}?debug=1`
        : DELETE_BOMCHECKLIST + `/${data.id}`,
    // body: data,
    headers: {
      authorization: "Bearer " + token,
    },
    success: "",
    failure: "",
    dispatch,
  });

  if (res.code >= 200 && res.code < 400) {
    return res;
  } else {
    if (res.message) toaster(ToastsStore, "error", res.message);
    return res;
  }
};

export const updateQuotes = (data) => (dispatch) => {
  dispatch({ type: UPDATE_QUOTES, data });
};

export const getRoles = (token) => async (dispatch) => {
  const data = await get({
    url:
      localStorage.getItem("isDebug") === "1"
        ? GET_ROLES + "?debug=1"
        : GET_ROLES,
    headers: {
      authorization: "Bearer " + token,
    },
    failure: "",
    dispatch,
  });

  if (data.code === 403) {
    return dispatch({ type: UNSET_USER });
  }

  if (data.code >= 200 && data.code < 400) {
    return data;
  } else {
    if (data.message) toaster(ToastsStore, "error", data.message);
    return data;
  }
};

export const getDistributor = (token) => async (dispatch) => {
  if (!token) {
    return { data: [] };
  }

  const data = await get({
    url:
      localStorage.getItem("isDebug") === "1"
        ? DISTRIBUTORS_LIST + "?debug=1"
        : DISTRIBUTORS_LIST,
    headers: {
      authorization: "Bearer " + token,
    },
    failure: "",
    dispatch,
  });

  if (data.code === 401 || data.code === 403) {
    dispatch({ type: UNSET_USER });
    return { data: [] };
  }

  if (data.code >= 200 && data.code < 400) {
    return {
      ...data,
      data: Array.isArray(data.data) ? data.data : [],
    };
  }

  if (data.message) toaster(ToastsStore, "error", data.message);
  return { data: [] };
};

export const getBomHistory = (token) => async (dispatch) => {
  const data = await get({
    url:
      localStorage.getItem("isDebug") === "1"
        ? BOM_HISTORY + "?debug=1"
        : BOM_HISTORY,
    headers: {
      authorization: "Bearer " + token,
    },
    failure: "",
    dispatch,
  });

  if (data.code === 401 || data.code === 403) {
    return dispatch({ type: UNSET_USER });
  }

  if (data.code >= 200 && data.code < 400) {
    return data;
  } else {
    if (data.message) toaster(ToastsStore, "error", data.message);
    return data;
  }
};

export const getBomDetails = (token, id) => async (dispatch) => {
  const data = await get({
    url:
      localStorage.getItem("isDebug") === "1"
        ? // eslint-disable-next-line no-useless-concat
          BOM_HISTORY + "/" + `${id}` + "?debug=1"
        : // eslint-disable-next-line no-useless-concat
          BOM_HISTORY + "/" + `${id}`,
    headers: {
      authorization: "Bearer " + token,
    },
    failure: "",
    dispatch,
  });

  if (data.code === 401 || data.code === 403) {
    return dispatch({ type: UNSET_USER });
  }

  if (data.code >= 200 && data.code < 400) {
    return data;
  } else {
    if (data.message) toaster(ToastsStore, "error", data.message);
    return data;
  }
};

export const getDigiKeyBomEnrichment = (token, bomId) => async (dispatch) => {
  const data = await get({
    url: `${DIGIKEY_ENRICH}?bom_id=${bomId}`,
    headers: {
      authorization: "Bearer " + token,
    },
    failure: "",
    dispatch,
  });

  if (data.code === 401 || data.code === 403) {
    return dispatch({ type: UNSET_USER });
  }

  return data;
};

export const getFile = (token, filePath) => async (dispatch) => {
  try {
    const data = await fetch(GET_FILE, {
      method: "GET",
      headers: {
        authorization: "Bearer " + token,
        "file-name": filePath,
      },
    });

    if (data && data.status >= 200 && data.status < 400) {
      return await data.blob();
    }
    if (data && data.status === 404) {
      toaster(ToastsStore, "error", "Could not find the file.");
    } else {
      toaster(ToastsStore, "error", "Could not get the file.");
    }
  } catch (error) {
    toaster(ToastsStore, "error", "Could not get the file.");
  }

  return null;
};

export const shareFile = (token, filePath, bomName) => async (dispatch) => {
  try {
    return await fetch(SHARE_BOM, {
      method: "GET",
      headers: {
        authorization: "Bearer " + token,
        "file-name": filePath,
        "bom-name": bomName,
      },
    });
  } catch (error) {
    toaster(ToastsStore, "error", "Could not share the BOM file.");
    return null;
  }
};

//--- Parts REVS
export const getPartsRevs = (token) => async (dispatch) => {
  const data = await get({
    url:
      localStorage.getItem("isDebug") === "1"
        ? PARTS_REVS_LIST + "?debug=1"
        : PARTS_REVS_LIST,
    success: GET_PARTS_REVS,
    headers: {
      authorization: "Bearer " + token,
    },
    failure: "",
    dispatch,
  });

  if (data.code >= 200 && data.code < 400) {
    dispatch({ type: GET_PARTS_REVS, data });
    return data;
  } else {
    if (data.message) toaster(ToastsStore, "error", data.message);
    dispatch({ type: "" });
    return data;
  }
};

export const getPartsRevsByCustomerId =
  (token, customerId) => async (dispatch) => {
    const data = await get({
      url:
        localStorage.getItem("isDebug") === "1"
          ? PARTS_REVS_LIST + "/" + customerId + "?debug=1"
          : PARTS_REVS_LIST + "/" + customerId,
      success: GET_PARTS_REVS,
      headers: {
        authorization: "Bearer " + token,
      },
      failure: "",
      dispatch,
    });

    if (data.code >= 200 && data.code < 400) {
      dispatch({ type: GET_PARTS_REVS, data });
      return data;
    } else {
      if (data.message) toaster(ToastsStore, "error", data.message);
      dispatch({ type: "" });
      return data;
    }
  };

export const savePartsRevs = (token, data) => async (dispatch) => {
  const res = await post({
    url:
      localStorage.getItem("isDebug") === "1"
        ? SAVE_PARTS_REVS + "?debug=1"
        : SAVE_PARTS_REVS,
    body: data,
    headers: {
      authorization: "Bearer " + token,
    },
    success: "",
    failure: "",
    dispatch,
  });

  if (res.code >= 200 && res.code < 400) {
    dispatch({ type: ADD_PARTS_REVS, data: res.data });
    return res;
  } else {
    if (res.message) toaster(ToastsStore, "error", "There were some errors.");
    return res;
  }
};

export const updateVendor = (token, data) => async (dispatch) => {
  const res = await post({
    url:
      localStorage.getItem("isDebug") === "1"
        ? UPDATE_VENDOR_LIST + "?debug=1"
        : UPDATE_VENDOR_LIST,
    body: data,
    headers: {
      authorization: "Bearer " + token,
    },
    success: "",
    failure: "",
    dispatch,
  });

  if (res.code >= 200 && res.code < 400) {
    // dispatch({ type: UPDATE_VENDOR, data:res.data })
    return res;
  } else {
    if (res.message) toaster(ToastsStore, "error", res.message);
    return res;
  }
};

export const storeResultantBom = async (token, data) => {
  const formData = new FormData();
  formData.append("bom_id", data.bomId);
  formData.append("file_name", data.fileName);
  formData.append("file", data.file);

  const res = await fetch(STORE_RESULTANT_BOM, {
    method: "POST",
    headers: {
      authorization: "Bearer " + token,
    },
    body: formData,
  });

  if (data.code >= 200 && data.code < 400) {
    return res;
  } else {
    if (res.message) toaster(ToastsStore, "error", res.message);
    return res;
  }
};

export const getAttritions = (token) => async (dispatch) => {
  const data = await get({
    url:
      localStorage.getItem("isDebug") === "1"
        ? GET_ATTRITIONS + "?debug=1"
        : GET_ATTRITIONS,
    headers: {
      authorization: "Bearer " + token,
    },
    failure: "",
    dispatch,
  });

  if (data.code >= 200 && data.code < 400) {
    return data;
  } else {
    if (data.message) toaster(ToastsStore, "error", data.message);
    return data;
  }
};

export const addAttrition = (token, data) => async (dispatch) => {
  const res = await post({
    url:
      localStorage.getItem("isDebug") === "1"
        ? ADD_ATTRITION + "?debug=1"
        : ADD_ATTRITION,
    body: data,
    headers: {
      authorization: "Bearer " + token,
    },
    success: "",
    failure: "",
    dispatch,
  });

  if (res.code >= 200 && res.code < 400) {
    return res;
  } else {
    if (res.message)
      // toaster(ToastsStore, 'error', res.message)
      return res;
  }
};

export const insertAttritionList = (token, data) => async (dispatch) => {
  const res = await post({
    url:
      localStorage.getItem("isDebug") === "1"
        ? INSERT_ATTRITION_LIST + "?debug=1"
        : INSERT_ATTRITION_LIST,
    body: { data },
    headers: {
      authorization: "Bearer " + token,
    },
    success: "",
    failure: "",
    dispatch,
  });

  if (res && res.code >= 200 && res.code < 400) {
    return res;
  }

  return res;
};

export const checkAttritionPackages = (token, packages) => async (dispatch) => {
  const res = await post({
    url:
      localStorage.getItem("isDebug") === "1"
        ? CHECK_ATTRITION_PACKAGES + "?debug=1"
        : CHECK_ATTRITION_PACKAGES,
    body: { data: packages },
    headers: {
      authorization: "Bearer " + token,
    },
    success: "",
    failure: "",
    dispatch,
  });

  if (res && res.code >= 200 && res.code < 400) {
    return res;
  }

  if (res?.message) toaster(ToastsStore, "error", res.message);
  return res;
};

export const editAttrition = (token, data) => async (dispatch) => {
  const res = await put({
    url:
      localStorage.getItem("isDebug") === "1"
        ? UPDATE_ATTRITION + `/${data.id}?debug=1`
        : UPDATE_ATTRITION + `/${data.id}`,
    body: data,
    headers: {
      authorization: "Bearer " + token,
    },
    success: "",
    failure: "",
    dispatch,
  });

  if (res.code >= 200 && res.code < 400) {
    return res;
  } else {
    if (res.message) toaster(ToastsStore, "error", res.message);
    return res;
  }
};

export const deleteAttrition = (token, data) => async (dispatch) => {
  const res = await delet({
    url:
      localStorage.getItem("isDebug") === "1"
        ? DELETE_ATTRITION + `/${data.id}?debug=1`
        : DELETE_ATTRITION + `/${data.id}`,
    body: data,
    headers: {
      authorization: "Bearer " + token,
    },
    success: "",
    failure: "",
    dispatch,
  });
  if (res.code >= 200 && res.code < 400) {
    return res;
  } else {
    if (res.message) toaster(ToastsStore, "error", res.message);
    return res;
  }
};

export const getPartsCatalog = (token, params = {}, signal) => async (dispatch) => {
  const searchParams = new URLSearchParams();
  if (params.page) searchParams.set("page", String(params.page));
  if (params.per_page) searchParams.set("per_page", String(params.per_page));
  if (params.search) searchParams.set("search", String(params.search));
  if (params.mounting_type) {
    searchParams.set("mounting_type", String(params.mounting_type));
  }
  if (params.part_status) {
    searchParams.set("part_status", String(params.part_status));
  }
  if (params.country_of_origin) {
    searchParams.set("country_of_origin", String(params.country_of_origin));
  }
  if (params.sort) searchParams.set("sort", String(params.sort));
  if (params.dir) searchParams.set("dir", String(params.dir));
  if (localStorage.getItem("isDebug") === "1") {
    searchParams.set("debug", "1");
  }
  const query = searchParams.toString();
  try {
    const data = await get({
      url: query ? `${GET_PARTS_CATALOG}?${query}` : GET_PARTS_CATALOG,
      headers: {
        authorization: "Bearer " + token,
      },
      failure: "",
      dispatch,
      signal,
    });

    if (data.code >= 200 && data.code < 400) {
      return data;
    }
    if (data.message) toaster(ToastsStore, "error", data.message);
    return data;
  } catch (error) {
    if (error && error.name === "AbortError") {
      throw error;
    }
    throw error;
  }
};

export const deletePart = (token, data) => async (dispatch) => {
  const res = await delet({
    url:
      localStorage.getItem("isDebug") === "1"
        ? DELETE_PART + `/${data.id}?debug=1`
        : DELETE_PART + `/${data.id}`,
    body: data,
    headers: {
      authorization: "Bearer " + token,
    },
    success: "",
    failure: "",
    dispatch,
  });
  if (res && res.code >= 200 && res.code < 400) {
    return res;
  }
  if (res && res.message) toaster(ToastsStore, "error", res.message);
  return res;
};

export const getPackageLeadTypes = (token) => async (dispatch) => {
  const data = await get({
    url:
      localStorage.getItem("isDebug") === "1"
        ? GET_PACKAGE_LEAD_TYPES + "?debug=1"
        : GET_PACKAGE_LEAD_TYPES,
    headers: {
      authorization: "Bearer " + token,
    },
    failure: "",
    dispatch,
  });

  if (data.code >= 200 && data.code < 400) {
    return data;
  } else {
    if (data.message) toaster(ToastsStore, "error", data.message);
    return data;
  }
};

export const addPackageLeadType = (token, data) => async (dispatch) => {
  const res = await post({
    url:
      localStorage.getItem("isDebug") === "1"
        ? ADD_PACKAGE_LEAD_TYPE + "?debug=1"
        : ADD_PACKAGE_LEAD_TYPE,
    body: data,
    headers: {
      authorization: "Bearer " + token,
    },
    success: "",
    failure: "",
    dispatch,
  });

  if (res.code >= 200 && res.code < 400) {
    return res;
  } else {
    return res;
  }
};

export const editPackageLeadType = (token, data) => async (dispatch) => {
  const res = await put({
    url:
      localStorage.getItem("isDebug") === "1"
        ? UPDATE_PACKAGE_LEAD_TYPE + `/${data.id}?debug=1`
        : UPDATE_PACKAGE_LEAD_TYPE + `/${data.id}`,
    body: data,
    headers: {
      authorization: "Bearer " + token,
    },
    success: "",
    failure: "",
    dispatch,
  });

  if (res.code >= 200 && res.code < 400) {
    return res;
  } else {
    if (res.message) toaster(ToastsStore, "error", res.message);
    return res;
  }
};

export const deletePackageLeadType = (token, data) => async (dispatch) => {
  const res = await delet({
    url:
      localStorage.getItem("isDebug") === "1"
        ? DELETE_PACKAGE_LEAD_TYPE + `/${data.id}?debug=1`
        : DELETE_PACKAGE_LEAD_TYPE + `/${data.id}`,
    body: data,
    headers: {
      authorization: "Bearer " + token,
    },
    success: "",
    failure: "",
    dispatch,
  });
  if (res.code >= 200 && res.code < 400) {
    return res;
  } else {
    if (res.message) toaster(ToastsStore, "error", res.message);
    return res;
  }
};

export const getSystemSettings = (token) => async (dispatch) => {
  const data = await get({
    url:
      localStorage.getItem("isDebug") === "1"
        ? GET_SYSTEM_SETTINGS + "?debug=1"
        : GET_SYSTEM_SETTINGS,
    success: SET_SYSTEM_SETTINGS,
    headers: {
      authorization: "Bearer " + token,
    },
    failure: "",
    dispatch,
  });

  if (data.code >= 200 && data.code < 400) {
    dispatch({ type: SET_SYSTEM_SETTINGS, data });
    return data;
  } else {
    if (data.message) toaster(ToastsStore, "error", data.message);
    dispatch({ type: "" });
    return data;
  }
};

export const addSystemSetting = (token, data) => async (dispatch) => {
  const res = await post({
    url:
      localStorage.getItem("isDebug") === "1"
        ? ADD_SYSTEM_SETTING + "?debug=1"
        : ADD_SYSTEM_SETTING,
    body: data,
    headers: {
      authorization: "Bearer " + token,
    },
    success: "",
    failure: "",
    dispatch,
  });

  if (res.code >= 200 && res.code < 400) {
    return res;
  } else {
    if (res.message)
      // toaster(ToastsStore, 'error', res.message)
      return res;
  }
};

export const editSystemSetting = (token, data) => async (dispatch) => {
  const res = await put({
    url:
      localStorage.getItem("isDebug") === "1"
        ? UPDATE_SYSTEM_SETTING + `/${data.id}?debug=1`
        : UPDATE_SYSTEM_SETTING + `/${data.id}`,
    body: data,
    headers: {
      authorization: "Bearer " + token,
    },
    success: "",
    failure: "",
    dispatch,
  });

  if (res.code >= 200 && res.code < 400) {
    return res;
  } else {
    if (res.message) toaster(ToastsStore, "error", res.message);
    return res;
  }
};

export const deleteSystemSetting = (token, data) => async (dispatch) => {
  const res = await delet({
    url:
      localStorage.getItem("isDebug") === "1"
        ? DELETE_SYSTEM_SETTING + `/${data.id}?debug=1`
        : DELETE_SYSTEM_SETTING + `/${data.id}`,
    body: data,
    headers: {
      authorization: "Bearer " + token,
    },
    success: "",
    failure: "",
    dispatch,
  });
  if (res.code >= 200 && res.code < 400) {
    return res;
  } else {
    if (res.message) toaster(ToastsStore, "error", res.message);
    return res;
  }
};
